/* INTEGY V461 — persistent collection filter layout contract.
   One breakpoint contract owns the filter presentation:
   - below 990px: phone/tablet drawer
   - 990px+ with a fine pointer/hover: persistent desktop sidebar
   The repair remains active after canonical/vehicle grid rebuilds instead of
   disconnecting after a short startup window. */
(function () {
  'use strict';
  if (window.INTEGY_V461_FILTER_LAYOUT_CONTRACT_LOADED) return;
  window.INTEGY_V461_FILTER_LAYOUT_CONTRACT_LOADED = true;
  window.INTEGY_V393_DESKTOP_FILTER_CONTRACT_LOADED = true;

  var applying = false;
  var scheduled = false;
  var observer = null;
  var observerMuted = false;

  function mm(query) {
    try { return !!(window.matchMedia && window.matchMedia(query).matches); }
    catch (error) { return false; }
  }

  function isDesktopSidebarMode() {
    if (!mm('(min-width: 990px)')) return false;
    /* A touch-capable Windows computer with a mouse should still receive the desktop sidebar. */
    return mm('(hover: hover) and (pointer: fine)') || Number(navigator.maxTouchPoints || 0) === 0;
  }

  function isCollectionLike() {
    var body = document.body;
    return !!(body && (
      body.classList.contains('template-collection') ||
      body.classList.contains('template-search') ||
      document.querySelector('.productgrid--outer')
    ));
  }

  function intAttr(element, name) {
    var value = element && element.getAttribute ? element.getAttribute(name) : '';
    var parsed = parseInt(value || '0', 10);
    return isFinite(parsed) ? parsed : 0;
  }

  function textLooksLikeFilters(element) {
    var text = (element && element.textContent || '').replace(/\s+/g, ' ').trim();
    return /Filters|Compatible models|Part, scale|Part, color|Filter by Vehicle|Filter by Tool|Clear filters|Completion level|Vehicle type/i.test(text);
  }

  function cleanInline(element) {
    if (!element || !element.style) return;
    [
      'display','visibility','opacity','transform','translate','left','right','top','bottom','inset','pointerEvents',
      'position','width','minWidth','maxWidth','height','minHeight','maxHeight','overflow','overflowX','overflowY',
      'float','clear','margin'
    ].forEach(function (property) {
      try { element.style[property] = ''; } catch (error) {}
    });
  }

  function unhide(element) {
    if (!element) return;
    cleanInline(element);
    try { element.hidden = false; } catch (error) {}
    if (element.removeAttribute) {
      element.removeAttribute('hidden');
      element.removeAttribute('aria-hidden');
      element.removeAttribute('inert');
    }
  }

  function findSidebarForOuter(outer) {
    if (!outer) return null;
    var sidebar = outer.querySelector('.productgrid--sidebar, [data-productgrid-sidebar], [data-integy-v393-desktop-filter-source]');
    if (sidebar) return sidebar;

    /* Recovery path when an older drawer controller moved the sidebar outside the collection shell. */
    var candidates = Array.prototype.slice.call(document.querySelectorAll(
      '.productgrid--sidebar, [data-productgrid-sidebar], [data-integy-v393-desktop-filter-source]'
    ));
    for (var index = 0; index < candidates.length; index += 1) {
      if (textLooksLikeFilters(candidates[index])) return candidates[index];
    }
    return null;
  }

  function shouldForceSidebar(outer, sidebar) {
    if (!outer || !sidebar) return false;
    if (outer.getAttribute('data-integy-suppress-filters') === 'true') return false;
    var count = Math.max(
      intAttr(outer, 'data-integy-result-count'),
      intAttr(outer, 'data-integy-v168-base-count')
    );
    return outer.getAttribute('data-integy-v353-force-filters') === 'true' || count > 0 || textLooksLikeFilters(sidebar);
  }

  function placeSidebar(outer, sidebar) {
    if (!outer || !sidebar) return;
    var wrapper = outer.querySelector('.productgrid--wrapper');
    if (!wrapper) return;
    if (sidebar.parentNode !== outer || sidebar.nextElementSibling !== wrapper) {
      try { outer.insertBefore(sidebar, wrapper); } catch (error) {}
    }
  }

  function closeLegacyDrawers() {
    var body = document.body;
    if (body) {
      body.classList.remove(
        'integy-v121-filter-open','integy-v124-filter-open','integy-v125-filter-open','integy-v128-filter-open','integy-v132-filter-open',
        'integy-v308-filter-open','integy-v328-filter-open','integy-v357-filter-open','integy-v358-filter-open','integy-v359-filter-open','integy-v360-filter-open'
      );
    }
    document.querySelectorAll(
      '.integy-v308-filter-backdrop,.integy-v328-filter-backdrop,.integy-v357-filter-backdrop,' +
      '.integy-v358-filter-backdrop,.integy-v359-filter-backdrop,.integy-v360-filter-backdrop'
    ).forEach(function (element) {
      element.setAttribute('aria-hidden', 'true');
      element.style.display = 'none';
      element.style.visibility = 'hidden';
      element.style.pointerEvents = 'none';
      element.style.opacity = '0';
    });
  }

  function restoreToolbar() {
    document.querySelectorAll('.productgrid--utils-container, [data-sticky-utils]').forEach(function (toolbar) {
      toolbar.classList.add('integy-v393-desktop-toolbar-restored', 'integy-v461-desktop-toolbar-restored');
      unhide(toolbar);
    });
    document.querySelectorAll('[data-utils-intersection-target], .productgrid--utils-sticky-intersection').forEach(function (element) {
      element.style.display = 'none';
      element.style.height = '0';
      element.style.minHeight = '0';
      element.style.margin = '0';
      element.style.padding = '0';
    });
  }

  function releaseDesktopContract() {
    var body = document.body;
    if (!body) return;
    body.classList.add('integy-v393-touch-handheld', 'integy-v461-drawer-contract-active');
    body.classList.remove('integy-v393-desktop-contract-active', 'integy-v461-desktop-sidebar-active');
    body.setAttribute('data-integy-v461-filter-layout', 'drawer');
    document.querySelectorAll('.productgrid--outer').forEach(function (outer) {
      outer.classList.remove('integy-v392-force-desktop-sidebar', 'integy-v393-force-desktop-sidebar', 'integy-v461-force-desktop-sidebar');
    });
  }

  function applyDesktopContract() {
    var body = document.body;
    if (!body) return;
    body.classList.remove('integy-v393-touch-handheld', 'integy-v461-drawer-contract-active');
    body.classList.add('integy-v393-desktop-contract-active', 'integy-v461-desktop-sidebar-active');
    body.setAttribute('data-integy-v461-filter-layout', 'sidebar');
    closeLegacyDrawers();

    document.querySelectorAll('.productgrid--outer').forEach(function (outer) {
      var sidebar = findSidebarForOuter(outer);
      if (!shouldForceSidebar(outer, sidebar)) return;

      outer.classList.add(
        'layout--has-sidebar',
        'integy-v392-force-desktop-sidebar',
        'integy-v393-force-desktop-sidebar',
        'integy-v461-force-desktop-sidebar'
      );
      outer.classList.remove('layout--no-sidebar', 'integy-v168-small-collection-no-filters');
      outer.setAttribute('data-integy-v461-sidebar-contract', 'active');

      placeSidebar(outer, sidebar);
      unhide(sidebar);
      sidebar.classList.add('integy-v393-desktop-sidebar-restored', 'integy-v461-desktop-sidebar-restored');
      sidebar.classList.remove(
        'integy-v121-filter-drawer','integy-v124-filter-drawer','integy-v125-filter-drawer','integy-v128-filter-drawer','integy-v132-filter-drawer',
        'integy-v308-filter-drawer','integy-v328-filter-drawer','integy-v357-filter-drawer','integy-v358-filter-drawer','integy-v359-filter-drawer','integy-v360-active-sidebar'
      );

      var shell = sidebar.querySelector('[data-integy-v200-static-filter-shell], [data-integy-v393-filter-shell]');
      if (shell) unhide(shell);
      var wrapper = outer.querySelector('.productgrid--wrapper');
      if (wrapper) {
        wrapper.classList.remove('layout--no-sidebar');
        unhide(wrapper);
      }
    });
    restoreToolbar();
  }

  function apply() {
    scheduled = false;
    if (applying) return;
    applying = true;
    observerMuted = true;
    try {
      document.documentElement.classList.add('integy-v393-desktop-filter-contract', 'integy-v461-filter-layout-contract');
      if (!isCollectionLike()) return;
      if (isDesktopSidebarMode()) applyDesktopContract();
      else releaseDesktopContract();
    } finally {
      applying = false;
      setTimeout(function () { observerMuted = false; }, 0);
    }
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(apply);
  }

  function observeCollectionShell() {
    if (!window.MutationObserver || observer) return;
    var outer = document.querySelector('.productgrid--outer');
    var target = outer && (outer.closest('.shopify-section') || outer.parentElement) || document.body;
    if (!target) return;
    observer = new MutationObserver(function () { if (!observerMuted) scheduleApply(); });
    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class','style','hidden','aria-hidden','inert']
    });
  }

  function boot() {
    apply();
    observeCollectionShell();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  window.addEventListener('load', scheduleApply, { passive: true });
  window.addEventListener('pageshow', scheduleApply, { passive: true });
  window.addEventListener('resize', scheduleApply, { passive: true });
  window.addEventListener('orientationchange', scheduleApply, { passive: true });

  [
    'integy:v429:vehicle-filtered',
    'integy:v429:filter-rendered',
    'integy:v307:filter-rendered',
    'integy:v460:quickshop-ready',
    'integy:v461:filter-layout-refresh',
    'shopify:section:load'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleApply, false);
  });

  [80, 350, 900, 1800, 3500].forEach(function (delay) { setTimeout(scheduleApply, delay); });
})();
